export default __webpack_public_path__ + "static/media/pants-normal-3.ed6cd45a.png";